module.exports = __webpack_public_path__ + "09a3a1521c9c087ae33008abd505a05b.png";